<div class="rounded-xl bg-white shadow-md w-[200px]">
  <div class="flex items-center relative justify-center">
    @for(imgUrl of pet().files; track $index){
    <p-image [src]="imgUrl" [preview]="true" [class.hidden]="$index != photoIndex()"
      imageClass="rounded-t-xl h-[200px] w-[200px] object-cover"
      [alt]="`${pet().name} - ${$index + 1} de ${pet().files.length}`" />
    }
    @if(!pet().files.length){
    <p-image src="/assets/logos/favicon.ico" [preview]="true" imageClass="rounded-t-xl p-3 h-[200px]"
      [alt]="`${pet().name} de ${pet().files.length}`" />
    }
    <button
      class="absolute left-2 bg-white hover:bg-gray-200 active:scale-95 transition duration-200 p-2 rounded-full cursor-pointer"
      (click)="onChangePhoto(-1)">
      <fa-icon class="text-blue-500" [icon]="arrowLeft"></fa-icon>
    </button>
    <button
      class="absolute right-2 bg-white hover:bg-gray-200 active:scale-95 transition duration-200 p-2 rounded-full cursor-pointer"
      (click)="onChangePhoto(1)">
      <fa-icon class="text-blue-500" [icon]="arrowRight"></fa-icon>
    </button>
  </div>
  <section class="px-2 py-4 cursor-pointer active:scale-95" (click)="onClick()">
    <p class="text-blue-500 text-center font-semibold text-lg overflow-hidden text-ellipsis whitespace-nowrap">
      {{ pet().name }}
    </p>
    <div class="flex flex-wrap mt-2 justify-center gap-2">
      @for(tag of tags(); track tag.name) {
      <span
        class="bg-gray-200 text-gray-600 hover:bg-blue-200 hover:text-blue-600 hover:scale-105 transition duration-200 px-2 py-1 font-semibold rounded-2xl"
        [title]="tag.name">{{ tag.value }}</span>
      }
    </div>
  </section>
</div>